// Project
var SFL = require('./project.js');

// Helpers
var Helpers = require('./helpers');

// Webfont
var Webfont = require('./modules/webfont.js');
SFL.Webfont = Webfont({
    fonts: ['Roboto Condensed', 'Roboto Condensed:300', 'Roboto', 'Roboto:300', 'Roboto:bold', 'Roboto:italic']
});

// Test
var Test = require('./modules/test.js');
SFL.Test = Test($('.test-outer-wrapper'));
